import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {SENTRY_PROVIDERS} from "../sentry.config.ng";
import { NotFoundComponent } from './not-found/not-found.component';

import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ImageModule } from 'primeng/image';
import { ToastModule } from "primeng/toast";
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { httpAuthInterceptorProviders } from './core/interceptors/auth-interceptor';
@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ImageModule,
    ButtonModule,
    ConfirmDialogModule,
    DynamicDialogModule,
    DialogModule,
    ToastModule,
    OverlayPanelModule
  ],
  providers: [
    ...SENTRY_PROVIDERS(),
    httpAuthInterceptorProviders
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
